module.exports = __webpack_public_path__ + "static/media/catedral-capa.ec597f29.png";